import { Region } from 'components/common/types'
import {
  HOMEPAGE_REGIONS_REQUEST,
  HOMEPAGE_REGIONS_SUCCESS,
  HOMEPAGE_REGIONS_FAILURE
} from '../constants'

type IHomepageReducer = {
  regions: {
    data: Region[]
    isLoading: boolean
    error: string | null
  }
}

const initialState: IHomepageReducer = {
  regions: {
    data: [],
    isLoading: false,
    error: null
  }
}

const HomepageReducer = (
  state: IHomepageReducer = initialState,
  action
): IHomepageReducer => {
  switch (action.type) {
    case HOMEPAGE_REGIONS_REQUEST:
      return {
        ...state,
        regions: {
          ...state.regions,
          isLoading: true
        }
      }

    case HOMEPAGE_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      }

    case HOMEPAGE_REGIONS_FAILURE:
      return {
        ...state,
        regions: {
          data: state.regions.data,
          isLoading: false,
          error: action.payload
        }
      }

    default:
      return state
  }
}

export default HomepageReducer
